import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Text from 'components/common/Text/Text'
import Modal from 'components/common/Modal'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Button from 'components/common/Button/Button'


const ActionConfirmationModal = ({
  confirmationExplanation,
  handleCancel,
  handleHide,
  handleUpdate
}) =>
  <CustomModal
    data-at-editvehicleconfirmationmodal
    title="Are you sure?"
    closeHandler={ handleHide }>
    <Text data-at-text>{ confirmationExplanation }</Text>
    <ButtonsWrapper>
      <Button data-at-editvehicleconfirmationmodal-apply full="mobile" stacked="mobile" onClick={ handleUpdate }>
        Apply Vehicle Updates
      </Button>
      <Button data-at-editvehicleconfirmationmodal-cancel link full="mobile" stacked="mobile" onClick={ handleCancel }>
        Cancel Updates
      </Button>
    </ButtonsWrapper>
  </CustomModal>

export default ActionConfirmationModal

ActionConfirmationModal.propTypes = {
  confirmationExplanation: PropTypes.string,
  handleCancel: PropTypes.func,
  handleHide: PropTypes.func,
  handleUpdate: PropTypes.func
}

const CustomModal = styled(Modal)`
  ${Media.desktop`
    padding: 25px 24px 67px;
  `}
`

const ButtonsWrapper = styled.div`
  ${Mixin.responsive('margin-top', '40px', '20px')}
`
